import { Box, Typography } from '@mui/material';

const toneMap = {
  primary: { bg: '#EFF6FF', iconBg: '#DBEAFE', iconColor: '#2563EB', valueColor: '#2563EB' },
  success: { bg: '#ECFDF5', iconBg: '#D1FAE5', iconColor: '#059669', valueColor: '#059669' },
  warning: { bg: '#FFF7ED', iconBg: '#FED7AA', iconColor: '#C2410C', valueColor: '#C2410C' },
  danger: { bg: '#FEF2F2', iconBg: '#FECACA', iconColor: '#DC2626', valueColor: '#DC2626' },
  neutral: { bg: '#F8FAFC', iconBg: '#E2E8F0', iconColor: '#475569', valueColor: '#334155' },
};

function StatsCard({ title, value, subtitle, icon, tone = 'primary' }) {
  const palette = toneMap[tone] || toneMap.primary;

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '13px',
        padding: '16px',
        boxShadow: '0 3px 14px rgba(30, 55, 90, 0.04)',
        border: '1px solid #e9edf4',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5 }}>
        <Box>
          <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#13213d', mb: 0.5 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography sx={{ fontSize: '12px', color: '#94A3B8' }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: '14px',
            backgroundColor: palette.bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: palette.iconColor,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      </Box>

      <Box
        sx={{
          pt: .25,
        }}
      >
        <Typography sx={{ fontSize: '31px', fontWeight: 750, color: '#0d1932', lineHeight: 1.1 }}>
          {value?.toLocaleString('tr-TR') || 0}
        </Typography>
        <Typography sx={{ fontSize: 11, color: '#8b98b0', mt: 1.5 }}>Güncel kayıtlar</Typography>
      </Box>
    </Box>
  );
}

export default StatsCard;
